//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    constants: {
        optionHeight: 32,
        optionsHeight: 160,
    },

    props: {
        value: String,
        label: String,
        minTime: String,
        maxTime: String,
    },

    data() {
        return {
            options: _.flatMap(_.range(0, 24), n => [`${n}:00`, `${n}:30`]),
            optionProps: [],
            optionEvents: [],
            focusedOptionIndex: null,
        };
    },

    computed: {
        filteredOptions() {
            return this.options.filter(this.isWithinBounds);
        },
    },

    methods: {
        isWithinBounds(value) {
            return (
                (!this.minTime || value.padStart(5, '0') >= this.minTime) &&
                (!this.maxTime || value.padStart(5, '0') <= this.maxTime)
            );
        },
        filterFn(text, update) {
            update(() => {
                const value = text || this.value;
                const d = dayjs(value, $.timeFormat);

                // Additional regex is used to work around dayjs' non-strict parsing (e.g. 10:1 is parsed as 10:01)
                if (/[0-2]?[0-9]:[0-5][0-9]/.test(value) && d.isValid() && this.isWithinBounds(value)) {
                    let sameIndex = this.filteredOptions.findIndex(o => dayjs(o, $.timeFormat).isSame(d));
                    let nextIndex = this.filteredOptions.findIndex(o => dayjs(o, $.timeFormat).isAfter(d));

                    if (nextIndex === -1) {
                        nextIndex = this.filteredOptions.length;
                    }

                    setTimeout(() => this.scrollToIndex(nextIndex - 1, true), 1);

                    // Note: Can be set halfway between two integral indices
                    this.focusedOptionIndex = (sameIndex !== -1) ? sameIndex : nextIndex - .5;

                    if (text && text !== this.value) {
                        this.$emit('input', text);
                    }
                }
            });
        },
        // This hack enables passing item props and events to options
        // rendered in custom scroll area in before-options slot
        saveOptionData(index, itemProps, itemEvents) {
            this.optionProps[index] = itemProps;
            this.optionEvents[index] = itemEvents;
        },
        scrollToIndex(index, centered) {
            if (!this.$refs.options)
                return;

            if (centered) {
                this.$refs.options.setScrollPosition(this.optionHeight * (index - 2));

                return;
            }

            const height = Math.min(this.optionsHeight, document.documentElement.clientHeight * .65);
            const oldY = this.$refs.options.getScrollPosition();
            const minNewY = this.optionHeight * (index + 1) - height;
            const maxNewY = this.optionHeight * index;

            if (oldY < minNewY) {
                this.$refs.options.setScrollPosition(minNewY);
            } else if (oldY > maxNewY) {
                this.$refs.options.setScrollPosition(maxNewY);
            }
        },
        onKeyDown(ev) {
            const isUp = (ev.which === 38);
            const isDown = (ev.which === 40);

            if (isUp || isDown) {
                const len = this.filteredOptions.length;
                let index = this.focusedOptionIndex;

                // Nudge up or down (in a way that works for half-values as well)
                index = Math.round(index + (isUp ? -.6 : .6));

                // Wrap around (-1 is a valid index representing 'no focused option')
                if (index > len - .5) {
                    index = -1;
                } else if (index < -1.5) {
                    index = len - 1;
                }

                // Ensure index is within bounds
                index = Math.max(-1, Math.min(len - 1, index));

                // Set QSelect's internal focused option index
                this.$refs.select.setOptionIndex(index);

                this.scrollToIndex(index, false);

                this.focusedOptionIndex = index;
            }
        },
    },
};
